import { render, staticRenderFns } from "./LeftBarHome.vue?vue&type=template&id=01b979cd&scoped=true"
import script from "./LeftBarHome.vue?vue&type=script&lang=js"
export * from "./LeftBarHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b979cd",
  null
  
)

export default component.exports